/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询我的品牌会员卡和权益
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class MemberEquitiesClubParams {
  constructor(public cardId: string) {}
}

export default async function (
  params: MemberEquitiesClubParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.MemberEquitiesDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/equities/card`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
